module.exports = __webpack_public_path__ + "img/backdrop-left.16787863.svg";